var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"bg-white p-3"},[_c('PageHeaderUI',{attrs:{"back":"","title":"Cards","breadcrumb":"Settings > Cards"}}),_c('div',[_c('Cards')],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }